import React, { HTMLProps } from "react";
import './ItemsToggler.scss';
import { Switch } from '@progress/kendo-react-inputs';
import { width } from "@mui/system";

export type TogglerItem = {
  id: string;
  value: string;
  isSelected: boolean;
  isAdditional: boolean;
}

type ItemsTogglerProps = HTMLProps<HTMLDivElement> & {
  items: TogglerItem[] | undefined;
  onItemToggle?: (item: TogglerItem) => void;
};

const ItemsToggler: React.FC<ItemsTogglerProps> = ({
  items,
  onItemToggle
}) => {

  return (
    <div className="items-toggler" >
      <ol>
        {items?.map((item) => (
          <li key={item.id} >
            <div className={`item item-${item.isSelected ? 'selected' : ''}`}>
              <div className='item-value'>{item.value}</div>
              <div>
                <Switch
                  checked={item.isSelected}
                  onChange={() => onItemToggle && onItemToggle(item)}
                />
              </div>
            </div>
          </li>
        ))}
      </ol>
    </div>
  );
}

export default ItemsToggler;